import { request } from "../httpClient";

function getUrl(prefixKey) {
  const prefix = (window.appConfig && window.appConfig[prefixKey]);
  return process.env.REACT_APP_API_URL + prefix;
}

export async function fetchSimulatedMetricsBySiteId({ queryKey }) {
  const [, siteId, start_date, end_date, metric_types, timeout] = queryKey;

  const base = `${getUrl("getSimMetricsUrl")}${siteId}`;
  const params = new URLSearchParams({
    start_date,
    end_date,
  });

  // metric_types can be undefined/null or an array of strings
  if (Array.isArray(metric_types) && metric_types.length) {
    for (const mt of metric_types) params.append("metric_types", mt);
  }

  const url = `${base}?${params.toString()}`;
  return request(url, {}, timeout);
}
